import Vue from 'vue';
import campaignTransformer from './../../transformers/campaign';

const success = (campaign, resolve) => {
  resolve(campaign);
};

const failed = (errors, reject) => {
  reject(campaignTransformer.fetch(errors));
};

export default (id, campaign) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`news_campaigns/${id}`, campaign)
      .then(() => {
        success(campaign, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/campaign/update.js